import { Pagination as SwiperPagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import 'swiper/scss/pagination';

import { Pagination } from 'components/pagination/Pagination';

import { TaskData } from './TaskItem';
import { TaskItem } from './TaskItem';
import styles from './TasksList.module.scss';

type TasksListProps = {
  tasks: TaskData[];
  paginatedTasks: TaskData[];
  currentPage: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  shouldShowPagination: boolean;
  goToPage: (page: number) => void;
  goToNextPage: () => void;
  goToPreviousPage: () => void;
  onRegister?: (taskId: number) => void;
  onClaim?: (taskId: number) => void;
};

export const TasksList = ({
  tasks,
  paginatedTasks,
  currentPage,
  totalPages,
  hasNextPage,
  hasPreviousPage,
  shouldShowPagination,
  goToPage,
  goToNextPage,
  goToPreviousPage,
  onRegister,
  onClaim,
}: TasksListProps) => {
  return (
    <>
      {/* Desktop: grid + pagination */}
      <div className="tw-hidden xl:tw-block">
        <div className="tw-flex tw-flex-wrap tw-justify-center tw-gap-[20px]">
          {paginatedTasks.map((task) => (
            <TaskItem
              key={task.id}
              {...task}
              onRegister={task.status === 'available' ? () => onRegister?.(task.id) : undefined}
              onClaim={task.status === 'claimable' ? () => onClaim?.(task.id) : undefined}
            />
          ))}
        </div>
        {shouldShowPagination && (
          <div className="tw-mt-[30px]">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              hasNextPage={hasNextPage}
              hasPreviousPage={hasPreviousPage}
              goToPage={goToPage}
              goToNextPage={goToNextPage}
              goToPreviousPage={goToPreviousPage}
              variant="taskBased"
            />
          </div>
        )}
      </div>

      {/* Mobile: swiper */}
      <div className={`tw-mx-[-28px] tw-block tw-overflow-hidden xl:tw-hidden ${styles.swiperWrapper}`}>
        <Swiper
          // @ts-ignore
          modules={[SwiperPagination]}
          slidesPerView={1}
          spaceBetween={16}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            375: {
              slidesPerView: 1.2,
              spaceBetween: 10,
            },
            425: {
              slidesPerView: 1.3,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 2.3,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3.15,
              spaceBetween: 20,
            },
          }}
          centeredSlides
          pagination={{ clickable: true }}
          style={{ paddingBottom: 40, overflow: 'visible' }}
        >
          {tasks.map((task) => (
            <SwiperSlide key={task.id} className="tw-flex tw-justify-center">
              <TaskItem
                {...task}
                onRegister={task.status === 'available' ? () => onRegister?.(task.id) : undefined}
                onClaim={task.status === 'claimable' ? () => onClaim?.(task.id) : undefined}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
};
